module.exports = __webpack_public_path__ + "assets/img/202107-6W.4852ba29.png";